import {
  Person,
  PersonContactDetailsItem,
} from '@aibees/elephant/feature/search-table-people/types';
import { Dispatch, SetStateAction } from 'react';
import { Certification } from './components/certification';
import { Education } from './components/education';
import { Languages } from './components/languages';
import { Projects } from './components/projects';
import { Publications } from './components/publications';
import { Recommendations } from './components/recommendations';
import { Volunteer } from './components/volunteer';
import { WorkHistory } from './components/work-history';
import {
  ContactDetailsSliderTabTitle,
  PeopleContactDetailItem,
  REF_NAMES,
  TabsRefNameMapperType,
  TabsUpdatesMapperType,
} from './types';

export function createTabConfig(data?: Person) {
  const PEOPLE_CONTACT_DETAIL_TABS: PeopleContactDetailItem[] = [
    {
      value: '0',
      label: ContactDetailsSliderTabTitle.Work_History,
      key: ContactDetailsSliderTabTitle.Work_History,
      icon: 'work-history-outline',
      disabled: !data?.positionGroups?.length,
    },
    {
      value: '1',
      label: ContactDetailsSliderTabTitle.Education,
      key: ContactDetailsSliderTabTitle.Education,
      icon: 'menu-book',
      disabled: !data?.educations?.length,
    },
    {
      value: '2',
      label: ContactDetailsSliderTabTitle.Publications,
      key: ContactDetailsSliderTabTitle.Publications,
      icon: 'sticky-note',
      disabled: !data?.publications?.length,
    },
    {
      value: '3',
      label: ContactDetailsSliderTabTitle.Volunteer,
      key: ContactDetailsSliderTabTitle.Volunteer,
      icon: 'volunteer',
      disabled: !data?.volunteerExperiences?.length,
    },
    {
      value: '4',
      label: ContactDetailsSliderTabTitle.Projects,
      key: ContactDetailsSliderTabTitle.Projects,
      icon: 'yard',
      disabled: !data?.projects?.length,
    },
    {
      value: '5',
      label: ContactDetailsSliderTabTitle.Language,
      key: ContactDetailsSliderTabTitle.Language,
      icon: 'language',
      disabled: !data?.languages?.profile_languages?.length,
    },
    {
      value: '6',
      label: ContactDetailsSliderTabTitle.Certification,
      key: ContactDetailsSliderTabTitle.Certification,
      icon: 'verified',
      disabled: !data?.certifications?.length,
    },
    {
      value: '7',
      label: ContactDetailsSliderTabTitle.Recommendations,
      key: ContactDetailsSliderTabTitle.Recommendations,
      icon: 'recommend',
      disabled: true, // TODO: this value will change whenever the back-end API is ready
    },
  ];

  return PEOPLE_CONTACT_DETAIL_TABS;
}

export const tabsRefNameMapper: TabsRefNameMapperType = {
  [ContactDetailsSliderTabTitle.Work_History]: REF_NAMES.workHistoryRef,
  [ContactDetailsSliderTabTitle.Education]: REF_NAMES.educationRef,
  [ContactDetailsSliderTabTitle.Publications]: REF_NAMES.publicationsRef,
  [ContactDetailsSliderTabTitle.Volunteer]: REF_NAMES.volunteerRef,
  [ContactDetailsSliderTabTitle.Projects]: REF_NAMES.projectsRef,
  [ContactDetailsSliderTabTitle.Language]: REF_NAMES.languagesRef,
  [ContactDetailsSliderTabTitle.Certification]: REF_NAMES.certificationRef,
  [ContactDetailsSliderTabTitle.Recommendations]: REF_NAMES.recommendationsRef,
};

export const tabsUpdatesMapper: TabsUpdatesMapperType = {
  [ContactDetailsSliderTabTitle.Work_History]:
    PersonContactDetailsItem.EXPERIENCE,
  [ContactDetailsSliderTabTitle.Education]: PersonContactDetailsItem.EDUCATIONS,
  [ContactDetailsSliderTabTitle.Publications]:
    PersonContactDetailsItem.PUBLICATIONS,
  [ContactDetailsSliderTabTitle.Volunteer]:
    PersonContactDetailsItem.VOLUNTEER_EXPERIENCES,
  [ContactDetailsSliderTabTitle.Projects]: PersonContactDetailsItem.PROJECTS,
  [ContactDetailsSliderTabTitle.Language]: PersonContactDetailsItem.LANGUAGES,
  [ContactDetailsSliderTabTitle.Certification]:
    PersonContactDetailsItem.CERTIFICATIONS,
  [ContactDetailsSliderTabTitle.Recommendations]:
    PersonContactDetailsItem.RECOMMENDATION,
};

export const createConfig = (
  setShowSeeMore: Dispatch<SetStateAction<boolean>>
) => [
  {
    component: <WorkHistory key="0" setShowSeeMore={setShowSeeMore} />,
    refName: tabsRefNameMapper[ContactDetailsSliderTabTitle.Work_History],
    active: true,
  },
  {
    component: <Education key="1" setShowSeeMore={setShowSeeMore} />,
    refName: tabsRefNameMapper[ContactDetailsSliderTabTitle.Education],
    active: true,
  },
  {
    component: <Publications key="2" setShowSeeMore={setShowSeeMore} />,
    refName: tabsRefNameMapper[ContactDetailsSliderTabTitle.Publications],
    active: true,
  },
  {
    component: <Volunteer key="3" setShowSeeMore={setShowSeeMore} />,
    refName: tabsRefNameMapper[ContactDetailsSliderTabTitle.Volunteer],
    active: true,
  },
  {
    component: <Projects key="5" setShowSeeMore={setShowSeeMore} />,
    refName: tabsRefNameMapper[ContactDetailsSliderTabTitle.Projects],
    active: true,
  },
  {
    component: <Languages key="6" setShowSeeMore={setShowSeeMore} />,
    refName: tabsRefNameMapper[ContactDetailsSliderTabTitle.Language],
    active: true,
  },
  {
    component: <Certification key="7" setShowSeeMore={setShowSeeMore} />,
    refName: tabsRefNameMapper[ContactDetailsSliderTabTitle.Certification],
    active: true,
  },
  {
    component: <Recommendations key="6" setShowSeeMore={setShowSeeMore} />,
    refName: tabsRefNameMapper[ContactDetailsSliderTabTitle.Recommendations],
    active: true,
  },
];
